var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeigen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Neigen__Icn/40px/Neigen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Neigen__Color/20px/Platzhalter-Transparent",
    fillRule: "nonzero",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Neigen__Rectangle",
    d: "M0 0H40V40H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.0024825,21 L12.9975175,21 C12.732258,21 12.4778664,21.1053909 12.2903229,21.292981 L2.29280544,31.292981 C1.66296111,31.9229817 2.109155,33 3,33 L38,33 C38.890845,33 39.3370389,31.9229817 38.7071946,31.292981 L28.7096771,21.292981 C28.5221336,21.1053909 28.267742,21 28.0024825,21 Z M27.588,23 L35.586,31 L5.413,31 L13.411,23 L27.588,23 Z M29.1784668,7.64031219 C33.7501255,7.64031219 36.10701,11.6149784 36.1912036,17.1887178 L36.1935425,17.5 L34.1935425,17.5 C34.1935425,12.7217588 32.4307578,9.64031219 29.1784668,9.64031219 C26.1918549,9.64031219 24.3037903,10.7535426 21.6388399,13.8746001 L21.174031,14.429474 C21.0228307,14.613194 20.8689769,14.8030939 20.7121613,14.9993208 L24.9230769,15 L24.9230769,17 L17,17 L17,9.71428571 L19,9.71428571 L18.9999953,13.9453122 L19.180443,13.7167919 C19.3472714,13.5076342 19.5115572,13.3046174 19.6736082,13.107631 L20.1533654,12.5346522 C23.1532684,9.01896225 25.4576091,7.64031219 29.1784668,7.64031219 Z",
    id: ".._.._src_svg_Icn_40px_Neigen__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeigen);
export default __webpack_public_path__ + "static/media/Neigen.826c302d6333c9ccaa8a914de1b1bffd.svg";
export { ForwardRef as ReactComponent };